{
  "meta": {
    "author": "LiaScript",
    "version": "1.3",
    "lang": "de"
  },
  "sections": [
    {
      "meta": {
        "author": "LiaScript",
        "email": "author@web.de"
      },
      "indent": 1,
      "title": "Base",
      "body": "In the simplessssst cadsde, a ssssdsasfdasfdection consists of two strings for one for thes title and odne for the body. The3 indentation is a required value beessssn 0 and sssss6 sasn22222djjjj defiwness the nussmbewwr of startinwg hash-tags. For the __tieeetle__ and asdfthe __body__ elements it issasdfasd already possibjjjjhhlshhhhe to use *LiaScsript-syntax* disrectly."
    },
    {
      "title": "Codee--------------------------------",
      "indent": 2,
      "body": [
        {
          "type": "quiz",
          "quizType": "input",
          "solution": "liascripsssssst",
          "hints": ["asdfasfd", "asdfasfd"],
          "answer": ["asdasdfasdfasfdasdf", "asdfasfdasdfafdsafsd"]
        },
        {
          "type": "code",
          "body": ["// asdfasdf", "// asdfalsdfafsd"],
          "language": "cpp",
          "title": "tester.cpp",
          "execute": ["<script>", "@input", "</script>"],
          "attr": {
            "data-type": "none"
          }
        }
      ]
    },
    {
      "title": "Tables--------------------------------",
      "indent": 2,
      "body": [
        {
          "type": "table",
          "head": ["1", "2", "3"],
          "body": [
            ["a", "b", "c"],
            [
              "a",
              "b",
              {
                "type": "italic",
                "body": "italic text",
                "attr": "custom-style"
              }
            ]
          ],
          "attr": {
            "data-type": "none"
          }
        }
      ]
    },
    {
      "title": "XXXXXXXXXXXXXXXXXX ordered list",
      "indent": 2,
      "body": [
        {
          "type": "tasks",
          "body": ["XXXXXXXXX", "YYYYYYYYY", "dddddddd"],
          "done": [false, false, true]
        }
      ]
    },
    {
      "title": "ordered list",
      "indent": 2,
      "body": [
        {
          "type": "enumerate",
          "body": [
            "XXXXXXXXX",
            "YYYYYYYYY",
            {
              "type": "quote",
              "body": ["111111", "222222"]
            },
            "dddddddd"
          ]
        }
      ]
    },
    {
      "title": "unordered list",
      "indent": 2,
      "body": [
        {
          "type": "itemize",
          "body": [
            "XXXXXXXXX",
            "YYYYYYYYY",
            {
              "type": "quote",
              "body": ["111111", "222222"]
            },
            "dddddddd"
          ]
        }
      ]
    },
    {
      "title": "BlockQuote",
      "indent": 2,
      "body": [
        {
          "type": "quote",
          "by": "asdfasfd",
          "body": [
            "XXXXXXXXX",
            "YYYYYYYYY",
            {
              "type": "quote",
              "body": ["111111", "222222"]
            },
            "dddddddd"
          ]
        }
      ]
    },
    {
      "meta": {
        "author": "LiaScript",
        "email": "author@web.de"
      },
      "indent": 2,
      "title": "Paragraph",
      "body": [
        {
          "type": "paragraph",
          "body": "A paragraph can always be a simple string, that can already include __Markdown__/~LiaScript~."
        },
        {
          "type": "line"
        },
        {
          "type": "paragraph",
          "body": "It is possible to attach attributes to a block, with any kind of HTML parameter for styling and more...",
          "attr": {
            "style": "color: red;",
            "class": "css testing",
            "id": "someId"
          }
        },
        {
          "type": "paragraph",
          "body": [
            "It is possible",
            "ssssssssssssss",
            {
              "type": "input",
              "solution": "jjjj",
              "length": 22,
              "attr": {
                "style": "color: red"
              }
            },
            {
              "type": "select",
              "solution": 1,
              "body": [
                "a",
                "b",
                "c",
                {
                  "type": "html",
                  "htmlTag": "span",
                  "attr": {
                    "style": "color: red"
                  },
                  "body": ["asdfasdfas"]
                }
              ],
              "attr": {
                "style": "color: red"
              }
            },
            {
              "type": "html",
              "htmlTag": "span",
              "attr": {
                "style": "color: red"
              },
              "body": ["asdfasdfas"]
            },
            {
              "type": "bold",
              "body": "bold text",
              "attr": {
                "class": "highlighted"
              }
            },
            {
              "type": "italic",
              "body": "italic text",
              "attr": "custom-style"
            },
            {
              "type": "formula",
              "body": "E = mc^2",
              "attr": {
                "display": "block"
              }
            },
            {
              "type": "symbol",
              "body": "→",
              "attr": {
                "direction": "right"
              }
            },
            {
              "type": "string",
              "body": "plain text"
            },
            {
              "type": "strike",
              "body": "struck through text",
              "attr": {
                "reason": "outdated"
              }
            },
            {
              "type": "sup",
              "body": "superscript",
              "attr": null
            },
            {
              "type": "underline",
              "body": "underlined text",
              "attr": null
            },
            {
              "type": "code",
              "body": "const x = 42;",
              "attr": {
                "lang": "javascript"
              }
            },
            {
              "type": "effect",
              "body": "animated text",
              "attr": null,
              "start": 0,
              "stop": 5,
              "playback": true,
              "voice": "alice"
            },
            {
              "type": "footnote",
              "body": "footnote reference",
              "attr": {
                "id": "fn1"
              }
            },
            {
              "type": "html",
              "htmlTag": "div",
              "body": "custom HTML content",
              "attr": {
                "class": "container"
              }
            },
            {
              "type": "link",
              "linkType": "link",
              "alt": "Link text",
              "url": "https://example.com",
              "title": "Hover title",
              "attr": {
                "target": "_blank"
              }
            },
            {
              "type": "script",
              "body": ["// comment", "console.log('Hello');"],
              "attr": {
                "type": "text/javascript"
              }
            }
          ]
        }
      ]
    }
  ]
}
